import styled from '@emotion/styled';

const StyledLink = styled('a')(() => ({
    position: 'relative',
    display: 'block',
}));

export { StyledLink };
